export interface ISetting {
  id?: number;
  name?: string;
  value?: string;
  description?: string;
}

export class SettingDTO implements ISetting {
  id?: number;
  name: string;
  value: string;
  description: string;
}

export default class Setting extends SettingDTO {
  constructor(dto: SettingDTO) {
    super();
    if (dto) {
      Object.assign(this, dto);
    } else {
      this.new();
    }
  }

  public new() {
    Object.assign(this, {
      id: 0,
      name: "",
      value: "",
      description: "",
    });
  }
}
